import BasicDrawer from '@components/common/molecules/drawer/BasicDrawer';
import RestaurantOfferStore from "@components/offer/stores/RestaurantOfferStore";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import FoodAdditionalDrawerHeader from './FoodAdditionalDrawerHeader';
import FoodAdditionalDrawerView from './FoodAdditionalDrawerView';
import BottomAction from './actions/BottomAction';
import { Box } from '@mui/material';

interface FoodAdditionalDrawerProps {
    restaurantOfferStore: RestaurantOfferStore,
}

const FoodAdditionalDrawer: FC<FoodAdditionalDrawerProps> = observer(({ restaurantOfferStore }) => {
    const { isFoodAdditionalDrawerOpen, setIsFoodAdditionalDrawerOpen, orderFoodRequest } = restaurantOfferStore;

    const handleOnClose = () => {
        setIsFoodAdditionalDrawerOpen(false);
    }

    if (orderFoodRequest === undefined) {
        return null;
    }

    return (
        <BasicDrawer
            isOpen={isFoodAdditionalDrawerOpen}
            onClose={handleOnClose}
            header={<FoodAdditionalDrawerHeader restaurantOfferStore={restaurantOfferStore} />}>
            {orderFoodRequest &&
                <Box
                    p={2}
                    pt={0}
                    pb={{ xs: 12, md: 14 }}
                    position={"relative"}
                    sx={{
                        height: '100%',
                        overflow: 'auto',
                    }}
                >
                    <FoodAdditionalDrawerView restaurantOfferStore={restaurantOfferStore} />
                    <BottomAction restaurantOfferStore={restaurantOfferStore} />
                </Box>
            }
        </BasicDrawer>
    )
})

export default FoodAdditionalDrawer;